module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Light.1f242fe3aa2b3f983dcf2b85616a0136.eot";